import { useContext } from 'react';
import { StockOptionsContext } from './StockOptionsProvider';

export const useStockOptionsContext = () => {
  const context = useContext(StockOptionsContext);

  if (context === undefined) {
    throw new Error('useStockOptionsContext must be used within a StockOptionsProvider');
  }

  return context;
};
